/**
 * This is a list of team/workspace ids from PRODUCTION which won't have a
 * last active state displayed in the users table.
 */
const workspaceIdsWithHiddenLastActiveState = [
  // BARMER
  60149,
  // Urban Kita (single workspace from H.Boettger@urban-kita.de)
  1068166,
  // Urban Kita (another workspace with multiple members)
  1066355,
  // Urbanfab
  1066507,
  // Urbanfab 2?
  1068330,
  // Urban fab 3?
  1066423,
  // Urbanfab 4?
  1094523,
  // Urbanfab 5?
  1094526,
  // fab e.V.
  1094522,
];

export const isWorkspaceIdWithHiddenLastActiveState = (teamId: number | null) =>
  teamId && workspaceIdsWithHiddenLastActiveState.includes(teamId);
